import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'components/base/Button';

interface ConfirmationModalProps {
  show: boolean;
  title: string;
  message: string;
  details?: Array<{
    label: string;
    value: string;
  }>;
  confirmText?: string;
  cancelText?: string;
  hideCancel?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  title,
  message,
  details,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  hideCancel = false,
  onConfirm,
  onCancel
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      contentClassName="border-translucent"
    >
      <Modal.Header className="px-card border-0">
        <div className="w-100 d-flex justify-content-between align-items-center">
          <Modal.Title className="mb-0">{title}</Modal.Title>
          <Button className="p-1 fs-10 text-body" onClick={onCancel}>
            X
          </Button>
        </div>
      </Modal.Header>
      <Modal.Body className="p-card py-0">
        <p>{message}</p>
        {details && details.length > 0 && (
          <div className="mt-3">
            {details.map((detail, index) => (
              <div key={index} className="mb-2">
                <strong>{detail.label}</strong>: {detail.value}
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end border-0">
        {!hideCancel && (
          <Button variant="secondary" onClick={onCancel} className="me-2">
            {cancelText}
          </Button>
        )}
        <Button variant="primary" onClick={onConfirm}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
